module.exports = __webpack_public_path__ + "static/christianwork6-cc2999c05ab4819fee4cf4bf65abe681.jpg";